<template>
    <div>
        <ModalCommon :id="`configModalCommon-${config.id ?? ''}`" :config="config" @close="handleCloseModal()" :isView="true">
            <div>
                <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted" v-if="!config.isLoadingPreviewFAQ">
                    <div v-for="(item, k) in config.listFAQ" :key="k + 'SS'">
                        <b-tab class="border-0">
                            <template v-slot:title>
                                <span>{{ k }}</span>
                            </template>
                            <div class="faq_body">
                                <template v-for="(te, j) in item">
                                    <div class="style1" v-if="(j == 3 || (j >= 5 && j <= 7)) && k == '電話事務局'" :key="j">
                                        <pre>{{ te }}</pre>
                                    </div>
                                    <div class="style1" v-else-if="(j == 3 || (j >= 5 && j <= 7)) && k == 'メール事務局'" :key="j">
                                        <pre>{{ te }}</pre>
                                    </div>
                                    <pre v-else :key="j">{{ te }}</pre>
                                </template>
                            </div>
                        </b-tab>
                    </div>
                    <div v-for="(tab, idxT) in listTabs" :key="idxT">
                        <div v-for="(item, k) in config.listData" :key="k">
                            <b-tab class="border-0" v-if="tab == k">
                                <template v-slot:title>
                                    <span>{{ k }}</span>
                                </template>
                                <div class="faq_body">
                                    <table class="table table-bordered box6">
                                        <tr>
                                            <th>Q</th>
                                            <template v-for="tit in config.listTitle[k]">
                                                <th :key="tit">{{ tit }}</th>
                                                <th :key="`{{ $t('faq.patternAnswer') }}-${tit}`">{{ $t('faq.patternAnswer') }}</th>
                                            </template>
                                            <th class="text-nowrap">{{ $t('faq.messageTo') }}</th>
                                            <th class="text-nowrap">
                                                {{
                                                    config?.contextData?.client_name
                                                        ? `${config?.contextData?.client_name} ${$t('faq.secretariatNotices')}`
                                                        : `《クライアント名》/《主催者名》${$t('faq.secretariatNotices')}`
                                                }}
                                            </th>
                                        </tr>
                                        <tbody>
                                            <tr v-for="(jtem, ky) in item" :key="jtem.id" :index="indexDomTbody">
                                                <td style="position: relative; height: 1px">
                                                    <TextareaComponent
                                                        :id="`question-${jtem.id}`"
                                                        :model.sync="jtem.question"
                                                        :rows="`5`"
                                                        :class="`textarea_faq_document stretch_textarea ${jtem.is_disabled ? '' : 'disabled_not_restore'}`"
                                                        style="padding-top: 1.3rem"
                                                        :disabled="!showDataQ[jtem.id] || jtem?.is_disabled"
                                                    />
                                                    <template v-if="!jtem?.is_disabled">
                                                        <i
                                                            v-if="showDataQ[jtem.id]"
                                                            @click="updateDataQ(jtem, jtem.id, 'question')"
                                                            class="fa fa-save text-success icon_edit"
                                                            v-b-tooltip.hover="$t('btn.save')"
                                                        ></i>
                                                        <i
                                                            v-else
                                                            @click="setDataQ(jtem, 'question')"
                                                            class="fa fa-pencil-alt text-primary icon_edit"
                                                        ></i>
                                                        <i
                                                            @click="deleteDataQuestion(item, jtem, ky, tab, 'question')"
                                                            class="fa fa-trash text-danger icon_delete"
                                                        ></i>
                                                    </template>
                                                    <template v-else>
                                                        <i
                                                            @click="restoreDataFaqFollowType({ item, jtem, ky, tab }, 'question')"
                                                            class="mdi mdi-backup-restore text-info icon_restore"
                                                        ></i>
                                                    </template>
                                                </td>
                                                <template v-for="(tit, k) in config.listTitle[k]">
                                                    <th :key="tit + 'u'" class="checkHR">
                                                        <div v-for="(aS, key) in jtem.answers" :key="aS.id">
                                                            <div v-if="aS.category_id == k" style="position: relative">
                                                                <TextareaComponent
                                                                    :id="`answer-${aS.id}`"
                                                                    :model.sync="aS.answer"
                                                                    :rows="`4`"
                                                                    :class="`textarea_faq_document ${aS?.is_disabled || jtem?.is_disabled ? '' : 'disabled_not_restore'}`"
                                                                    :disabled="!showData[aS.id] || aS?.is_disabled"
                                                                />
                                                                <template v-if="!jtem?.is_disabled">
                                                                    <template v-if="!aS?.is_disabled">
                                                                        <i
                                                                            v-if="showData[aS.id]"
                                                                            @click="updateData(jtem, aS.id, 'answer')"
                                                                            class="fa fa-save text-success icon_edit_answer"
                                                                            v-b-tooltip.hover="$t('btn.save')"
                                                                        ></i>
                                                                        <i
                                                                            v-else
                                                                            @click="setData(aS, 'answer')"
                                                                            class="fa fa-pencil-alt text-primary icon_edit_answer"
                                                                        ></i>
                                                                        <i
                                                                            @click="deleteDataForType({ jtem, aS, key }, 'answer')"
                                                                            class="fa fa-trash text-danger icon_delete_answer"
                                                                        ></i>
                                                                    </template>
                                                                    <template v-else>
                                                                        <i
                                                                            @click="restoreDataFaqFollowType({ item, jtem, aS, ky, tab }, 'answer')"
                                                                            class="mdi mdi-backup-restore text-info icon_restore"
                                                                            style="top: -14px"
                                                                        ></i>
                                                                    </template>
                                                                </template>
                                                                <hr />
                                                            </div>
                                                        </div>
                                                    </th>
                                                    <th :key="tit + 'pattern'" class="checkHR">
                                                        <div v-for="(aS, key) in jtem.answers" :key="aS.id">
                                                            <div v-if="aS.category_id == k" style="position: relative">
                                                                <TextareaComponent
                                                                    :id="`pattern-${aS.id}`"
                                                                    :model.sync="aS.pattern"
                                                                    :rows="`4`"
                                                                    :class="`textarea_faq_document ${aS?.is_disabled_pattern || jtem?.is_disabled ? '' : 'disabled_not_restore'}`"
                                                                    :disabled="!showDataP[aS.id] || aS?.is_disabled_pattern"
                                                                />
                                                                <template v-if="!jtem?.is_disabled && !aS?.is_disabled">
                                                                    <template v-if="!aS?.is_disabled_pattern">
                                                                        <i
                                                                            v-if="showDataP[aS.id]"
                                                                            @click="updateData(jtem, aS.id, 'pattern')"
                                                                            class="fa fa-save text-success icon_edit_answer"
                                                                            v-b-tooltip.hover="$t('btn.save')"
                                                                        ></i>
                                                                        <i
                                                                            v-else
                                                                            @click="setData(aS, 'pattern')"
                                                                            class="fa fa-pencil-alt text-primary icon_edit_answer"
                                                                        ></i>
                                                                        <i
                                                                            @click="deleteDataForType({ jtem, aS, key }, 'pattern')"
                                                                            class="fa fa-trash text-danger icon_delete_answer"
                                                                        ></i>
                                                                    </template>
                                                                    <template v-else>
                                                                        <i
                                                                            @click="restoreDataFaqFollowType({ item, jtem, aS, ky, tab }, 'pattern')"
                                                                            class="mdi mdi-backup-restore text-info icon_restore"
                                                                            style="top: -14px"
                                                                        ></i>
                                                                    </template>
                                                                </template>
                                                                <hr />
                                                            </div>
                                                        </div>
                                                    </th>
                                                </template>
                                                <td style="position: relative; height: 1px">
                                                    <TextareaComponent
                                                        :id="`message_to-${jtem.id}`"
                                                        :model.sync="jtem.message_to"
                                                        :rows="`4`"
                                                        :class="`textarea_faq_document stretch_textarea ${jtem?.is_disabled_message_to || jtem?.is_disabled ? '' : 'disabled_not_restore'}`"
                                                        style="padding-top: 1.5rem"
                                                        :disabled="!showDataMessage[jtem.id] || jtem?.is_disabled_message_to"
                                                    />
                                                    <template v-if="jtem.message_to && !jtem?.is_disabled">
                                                        <template v-if="!jtem?.is_disabled_message_to">
                                                            <i
                                                                v-if="showDataMessage[jtem.id]"
                                                                @click="updateDataQ(jtem, jtem.id, 'messageTo')"
                                                                class="fa fa-save text-success icon_edit"
                                                                v-b-tooltip.hover="$t('btn.save')"
                                                            ></i>
                                                            <i
                                                                v-else
                                                                @click="setDataQ(jtem, 'messageTo')"
                                                                class="fa fa-pencil-alt text-primary icon_edit"
                                                            ></i>
                                                            <i
                                                                @click="deleteDataQuestion(item, jtem, ky, tab, 'messageTo')"
                                                                class="fa fa-trash text-danger icon_delete"
                                                            ></i>
                                                        </template>
                                                        <template v-else>
                                                            <i
                                                                @click="restoreDataFaqFollowType({ item, jtem, ky, tab }, 'messageTo')"
                                                                class="mdi mdi-backup-restore text-info icon_restore"
                                                            ></i>
                                                        </template>
                                                    </template>
                                                </td>
                                                <td style="position: relative; height: 1px">
                                                    <TextareaComponent
                                                        :id="`secretariat_notices-${jtem.id}`"
                                                        :model.sync="jtem.secretariat_notices"
                                                        :rows="`4`"
                                                        :class="`textarea_faq_document stretch_textarea ${jtem.is_disabled_secretariat_notices || jtem?.is_disabled ? '' : 'disabled_not_restore'}`"
                                                        style="padding-top: 1.5rem"
                                                        :disabled="!showDataSecretariat[jtem.id] || jtem?.is_disabled_secretariat_notices"
                                                    />
                                                    <template v-if="jtem.secretariat_notices && !jtem?.is_disabled">
                                                        <template v-if="!jtem?.is_disabled_secretariat_notices">
                                                            <i
                                                                v-if="showDataSecretariat[jtem.id]"
                                                                @click="updateDataQ(jtem, jtem.id, 'secretariatNotices')"
                                                                class="fa fa-save text-success icon_edit"
                                                                v-b-tooltip.hover="$t('btn.save')"
                                                            ></i>
                                                            <i
                                                                v-else
                                                                @click="setDataQ(jtem, 'secretariatNotices')"
                                                                class="fa fa-pencil-alt text-primary icon_edit"
                                                            ></i>
                                                            <i
                                                                @click="deleteDataQuestion(item, jtem, ky, tab, 'secretariatNotices')"
                                                                class="fa fa-trash text-danger icon_delete"
                                                            ></i>
                                                        </template>
                                                        <template v-else>
                                                            <i
                                                                @click="restoreDataFaqFollowType({ item, jtem, ky, tab }, 'secretariatNotices')"
                                                                class="mdi mdi-backup-restore text-info icon_restore"
                                                            ></i>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-tab>
                        </div>
                    </div>
                </b-tabs>
                <div v-else style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)">
                    <LoadingIcon />
                </div>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import { masterMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';

import LoadingIcon from '@/components/Loading/main.vue';
import ModalCommon from '@/components/Modal/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';

export default {
    name: 'PopUpFAQ',
    props: {
        config: {
            type: Object,
            required: false
        }
    },
    components: {
        LoadingIcon,
        ModalCommon,
        TextareaComponent
    },
    data() {
        return {
            showData: {},
            showDataQ: {},
            showDataP: {},
            showDataMessage: {},
            showDataSecretariat: {},
            backupEdits: {},
            listData: [],
            listTabs: [
                '電話事務局',
                'メール事務局',
                'キャンペーン全般',
                '抽選',
                '抽選（インスタントウィン）',
                '賞品',
                '高額賞品',
                '高額賞金',
                'キャッシュバック',
                '賞品（ｲﾍﾞﾝﾄ）',
                '賞品（OLｲﾍﾞﾝﾄ）',
                'WEB応募フォーム',
                'Lターゲット',
                '当選フォーム',
                '個人情報の取り扱い',
                'クレーム対応',
                'その他'
            ],
            indexDomTbody: 0,
            isProcessAnswerDelete: false,
            isProcessQuestionDelete: false,
            isProcessRestore: false
        };
    },
    methods: {
        ...masterMethods,

        saveEditBackup(targetObj, typeKey, objectKey, showKey) {
            this.$set(this.backupEdits, `${typeKey}-${targetObj.id}`, {
                target: targetObj,
                key: objectKey,
                value: targetObj[objectKey],
                showKey: showKey
            });
            this.$set(this[showKey], targetObj.id, true);
        },

        revertAllEdits() {
            Object.values(this.backupEdits).forEach((backup) => {
                this.$set(backup.target, backup.key, backup.value);
                this.$set(this[backup.showKey], backup.target.id, false);
            });
            this.backupEdits = {};
            this.$forceUpdate();
        },

        updateDataQ(object, key, typeKey = null) {
            this.updateDocumentFAQ(object).then((data) => {
                if (data.code == 200) {
                    switch (typeKey) {
                        case 'question':
                            this.$set(this.showDataQ, key, false);
                            break;
                        case 'messageTo':
                            this.$set(this.showDataMessage, key, false);
                            break;
                        case 'secretariatNotices':
                            this.$set(this.showDataSecretariat, key, false);
                            break;
                    }
                    this.$delete(this.backupEdits, `${typeKey}-${key}`);
                }
            });
        },

        setDataQ(jtem, typeKey = null) {
            let objKey = typeKey === 'question' ? 'question' : typeKey === 'messageTo' ? 'message_to' : 'secretariat_notices';
            let showKey = typeKey === 'question' ? 'showDataQ' : typeKey === 'messageTo' ? 'showDataMessage' : 'showDataSecretariat';
            this.saveEditBackup(jtem, typeKey, objKey, showKey);
        },

        async deleteDataQuestion(object, data, key, tab, typeKey = null) {
            if (this.isProcessQuestionDelete) return;
            this.revertAllEdits();
            this.isProcessQuestionDelete = true;
            switch (typeKey) {
                case 'question':
                    this.$set(this.showDataMessage, data.id, false);
                    this.$set(this.showDataSecretariat, data.id, false);
                    data.answers.forEach((item) => {
                        this.$set(this.showData, item.id, false);
                        this.$set(this.showDataP, item.id, false);
                    });
                    await this.deleteDocumentFAQ(data).catch((error) => {
                        showMessage(error.code, this.$bvToast, 'Lỗi xóa câu hỏi');
                        this.isProcessQuestionDelete = false;
                        return;
                    });
                    this.$set(data, 'is_disabled', true);
                    this.config.listData = JSON.parse(JSON.stringify(this.config.listData));
                    this.isProcessQuestionDelete = false;
                    break;
                case 'messageTo':
                    this.$set(data, 'is_disabled_message_to', true);
                    await this.updateDocumentFAQ(data).catch((error) => {
                        showMessage(error.code, this.$bvToast, 'Lỗi xóa thông báo');
                        this.isProcessQuestionDelete = false;
                        return;
                    });
                    this.config.listData[tab][key] = data;
                    this.config.listData = JSON.parse(JSON.stringify(this.config.listData));
                    this.isProcessQuestionDelete = false;
                    break;
                case 'secretariatNotices':
                    this.$set(data, 'is_disabled_secretariat_notices', true);
                    await this.updateDocumentFAQ(data).catch((error) => {
                        showMessage(error.code, this.$bvToast, 'Lỗi xóa thông báo');
                        this.isProcessQuestionDelete = false;
                        return;
                    });
                    this.config.listData[tab][key] = object[key];
                    this.config.listData = JSON.parse(JSON.stringify(this.config.listData));
                    this.isProcessQuestionDelete = false;
                    break;
            }
            this.onHandleUpdateTbodyIndex();
        },

        async restoreDataFaqFollowType(objectParam, typeKey = null) {
            const { jtem, aS } = objectParam;
            let payload = { campaign_id: this.config.contextData.id, faq_id: jtem.id };
            if (this.isProcessRestore) return;
            this.isProcessRestore = true;
            switch (typeKey) {
                case 'question':
                    try {
                        const response = await this.restoreDocumentFAQ(payload);
                        if (response.code == 200) {
                            this.$set(jtem, 'is_disabled', false);
                            this.$set(jtem, 'is_disabled_message_to', false);
                            this.$set(jtem, 'is_disabled_secretariat_notices', false);
                            if (jtem?.answers?.length > 0) {
                                jtem.answers.forEach((item) => {
                                    this.$set(item, 'is_disabled', false);
                                    this.$set(item, 'is_disabled_pattern', false);
                                });
                            }
                            this.config.listData = JSON.parse(JSON.stringify(this.config.listData));
                        }
                        this.isProcessRestore = false;
                    } catch (error) {
                        showMessage(error.code, this.$bvToast, 'Lỗi restore');
                        this.isProcessRestore = false;
                    }
                    break;
                case 'answer':
                case 'pattern':
                case 'messageTo':
                case 'secretariatNotices':
                    if (typeKey == 'answer') {
                        this.$set(aS, 'is_disabled', false);
                        this.$set(aS, 'is_disabled_pattern', false);
                    } else if (typeKey == 'pattern') {
                        this.$set(aS, 'is_disabled_pattern', false);
                    } else if (typeKey == 'messageTo') {
                        this.$set(jtem, 'is_disabled_message_to', false);
                    } else if (typeKey == 'secretariatNotices') {
                        this.$set(jtem, 'is_disabled_secretariat_notices', false);
                    }
                    await this.updateDocumentFAQ(jtem).catch((error) => {
                        showMessage(error.code, this.$bvToast, 'Lỗi restore');
                        this.isProcessRestore = false;
                    });
                    this.isProcessRestore = false;
                    break;
            }
            this.onHandleUpdateTbodyIndex();
        },

        updateData(object, key, typeKey = null) {
            this.updateDocumentFAQ(object).then((data) => {
                if (data.code == 200) {
                    switch (typeKey) {
                        case 'answer':
                            this.$set(this.showData, key, false);
                            break;
                        case 'pattern':
                            this.$set(this.showDataP, key, false);
                            break;
                    }
                    this.$delete(this.backupEdits, `${typeKey}-${key}`);
                }
            });
        },

        setData(aS, typeKey = null) {
            let showKey = typeKey === 'answer' ? 'showData' : 'showDataP';
            this.saveEditBackup(aS, typeKey, typeKey, showKey);
        },
        deleteDataForType(object, typeKey = null) {
            const { jtem, aS } = object;
            if (this.isProcessAnswerDelete) return;
            this.revertAllEdits();
            this.isProcessAnswerDelete = true;
            switch (typeKey) {
                case 'answer':
                    this.$set(aS, 'is_disabled', true);
                    this.$set(aS, 'is_disabled_pattern', true);
                    this.$set(this.showDataP, aS.id, false);
                    break;
                case 'pattern':
                    this.$set(aS, 'is_disabled_pattern', true);
                    break;
            }
            this.updateDocumentFAQ(jtem).then((data) => {
                if (data.code == 200) {
                    this.config.listData = JSON.parse(JSON.stringify(this.config.listData));
                }
                this.isProcessAnswerDelete = false;
            });
        },

        handleCloseModal() {
            this.config.model = false;
            this.$emit('closeModalFaq');
        },
        onHandleUpdateTbodyIndex() {
            this.indexDomTbody++;
            if (this.indexDomTbody > 1000) {
                this.indexDomTbody = 0;
            }
        }
    },
    watch: {
        config: {
            handler() {},
            deep: true
        }
    },
    mounted() {}
};
</script>
<style lang="scss">
.faq-modal-doc {
    .modal-body {
        padding: 0px;
    }

    .disabled_not_restore {
        input.disabled_cursor,
        textarea.disabled_cursor {
            background-color: inherit !important;
        }
    }
}
</style>

<style lang="scss" scoped>
.faq_body {
    height: calc(100vh - 135px - 137px);
    overflow: auto;
    .icon_edit,
    .icon_delete,
    .icon_restore,
    .icon_edit_answer,
    .icon_delete_answer {
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 999;
    }

    .icon_edit {
        right: 25px;
    }

    .icon_delete {
    }

    .icon_restore {
        top: -2px;
        font-size: 18px;
    }

    .icon_edit_answer {
        right: 20px;
        top: -8px;
    }
    .icon_delete_answer {
        right: 0px;
        top: -8px;
    }

    .textarea_faq_document {
        border: 0;
        min-width: 320px;
        padding-top: 1rem;
    }

    .stretch_textarea {
        height: 100%;
        ::v-deep textarea {
            height: 100%;
        }
    }
}
</style>
